<template lang="pug">
cadastrante-sicarf-retificacao(:idProcesso="idProcesso", :observer="observer")
</template>

<script>
import CadastranteSicarfRetificacao from '../../../../components/cadastro/CadastranteSicarfRetificacao'

export default {
  props: ['cadastro', 'observer', 'idProcesso'],

  components: {
    CadastranteSicarfRetificacao
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/Cadastrante.vue